import { Field } from "formik";
import React, { useEffect, useState } from "react";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import { Accordion, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import request from "../../services/request";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils";
export default function InfoBanksSubCategories(props) {
  const [refreshList, setRefreshList] = useState(false);
  const [parentId, setParentId] = useState(null);
  const [t, i18n] = useTranslation(); /* Added Line */
  const [configData, setConfigData] = useState(null);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);
  const [pageName, setPageName] = useState("");
  const [initialValues, setInitialValues] = useState({});
  let resetFilterForm = null;

  let id = new URLSearchParams(window.location.search).get("id");

  useEffect(() => {
    fetchInit();

    id = new URLSearchParams(window.location.search).get("id");
    if(resetFilterForm) {
      resetFilterForm();
      setFilters([])
    }

  }, [props.location.search]);

  const fetchInit = () => {
    setParentId(id);

    /* setFilters([{
      fieldName: "kategoriId",
      value: id,
      oper: "EQ"
    }]); */

    setRefreshList(!refreshList);
  };

  const onKategoriChanged = (bilgiBankasiId) => {
    setFilters([]);
    filters.push({
      fieldName: "bilgiBankasiId",
      value: bilgiBankasiId,
      oper: "EQ",
      joinEntity: null,
      type: null,
    });
    filters.push({
      fieldName: "parentId",
      value: parentId,
      oper: "EQ",
      joinEntity: null,
      type: null,
    });
  };

  const mapNativeDataBeforeList = (data) => {    
    return data.length ? data : undefined;    
  };

  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  {parentId && (
                    <Filters
                      configPointUrl="bilgi-bankasi/filter-config"
                      configParameterName="kategoriId"
                      configParameterValue={parentId}
                      configReqType={"POST"}
                      setConfigData={(data) => setConfigData(data)}
                      setRefreshList={setRefreshList}
                      refreshList={refreshList}
                      setFilters={setFilters}
                      resetFilterFormRef={_resetFilterForm => resetFilterForm = _resetFilterForm}
                      //hideResetButton={true}
                    >
                      <Field
                        name="kategoriName"
                        label={t("infoBanksCategories.kategoriAdi")}
                        colNumber="3"
                        oper="EQ"
                        component={Select}
                        placeholder={t("formFields.allPlaceHolder")}
                        options={configData && configData.altKategoriler}
                        onChangeFunc={(val) => {
                          /* setFilters([{
                                fieldName: "name",
                                value: val,
                                oper: "EQ",
                              },{
                                fieldName: "parentId",
                                value: parentId,
                                oper: "EQ",
                              }]); */
                        }}
                      />
                    </Filters>
                  )}
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {parentId && (
            <ListComponent
              entityName="bilgi-bankası-files"
              endpoint="bilgi-bankasi-file/get-files-id"
              keyField="id"
              fileNameField="fileName"
              /* specificKeyField="selectedId" */
              refreshList={refreshList}
              pageTitle={(title) =>
                (document.querySelector(
                  ".header-left .dashboard_bar"
                ).innerText = title)
              }
              mapNativeDataBeforeList={mapNativeDataBeforeList}
              columns={[
                {
                  dataField: "parentKategoriName",
                  text: `${t("demandList.ustKategoriAdi")}`,
                  sort: true,
                },
                {
                  dataField: "kategoriName",
                  text: `${t("demandList.kategoriAdi")}`,
                  sort: true,
                },
                {
                  dataField: "descr",
                  text: t("demandList.aciklama"),
                  sort: true,
                },
                {
                  dataField: "fileName",
                  text: t("tabs.dosyaAdi"),
                  sort: true,
                },
                {
                  dataField: "createdDate",
                  text: t("tabs.tarih"),
                  formatter: formatDate,
                  sort: true,
                },
                {
                  dataField: "cuser.fullName",
                  text: t("tabs.ekleyen"),
                  sort: true,
                },
              ]}
              customBody={{
                filters: [
                  ...filters,
                  {
                    fieldName: "kategoriId",
                    value: parentId,
                    oper: "EQ",
                    joinEntity: null,
                    type: null,
                  },
                ],
              }}
              actionButtonsObject={{
                actions: [
                  requestTo(ABT.DOWNLOAD, "bilgi-bankasi-file/download"),
                  requestTo(ABT.PREVIEW, "bilgi-bankasi-file/download")
                ],
                generator: DefaultActionButtonGenerator,
              }}
            />
          )}
        </div>
      </div>
    </Main>
  );
}
